export default __webpack_public_path__ + "static/media/text-size-increase.85179f66.svg";